import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum WarrntyItemAction {
  FETCH_OPTIONS = "FETCH_OPTIONS",
  SET_OPTIONS = "SET_OPTIONS",
  CLEAN_UP = "CLEAN_UP_WARRNTY_ITEM",
  ADD = "ADD",
  UPLOAD_INVOICE = "UPLOAD_INVOICE",
  SET_WARRNTYID_CLAIMID = "SET_WARRNTYID_CLAIMID",
  INVOICE_UPLOAD = "INVOICE_UPLOAD",
  SET_INVOICE_URL = "SET_INVOICE_URL",
  SHOW_SUCCES_MODAL = "SHOW_SUCCES_MODAL",
  HIDE_SUCCES_MODAL = "HIDE_SUCCES_MODAL",
}

export interface WarrntyItemState {
  warrantyId: string;
  claimId: string;
  options: {
    claimItemTypes: [];
    materialTypes: [];
    manufacturers: [];
    colors: [];
  };
  showSucessModal: boolean;
}

export type WarrntyItemActionTypes = ReturnType<
  InferValueTypes<typeof actions>
>;

export const WarrntyItemScope = "warrntyitem";
